<template>
  <div id = "introduction">
    <div id = "catch__container">
      <div id = "catch">自分に気づこう</div>
    </div>
    <img src="../assets/main.svg" width="70%"/>
    <div id = "sub">しるQは毎日変わる問いに答えることで本当の自分を発見するサービスです。Twitterでシェアしてみんなの価値観と比べてみましょう！
    </div>
    <div id = "widget__container">
      <Twitter/>
    </div>
    <AnswerBtn/>
    <Question/>
    <AnswerBtn/>
  </div>

</template>

<script>
  import Question from './Question'
  import AnswerBtn from './AnswerBtn'
  import Twitter from './Twitter'

    export default {
      name: "Intro",
      components : {
        Question,
        AnswerBtn,
        Twitter
      }
    }
</script>

<style scoped>
  #sub{
    margin:0px 25px 50px 25px;
    font-size: 18px;
    line-height:1.8em;
    text-align: left;
  }
  #catch__container{
    /*display: -webkit-flex;*/
    /*display: flex;*/
    /*-webkit-align-items: center; !* 縦方向中央揃え（Safari用） *!*/
    /*align-items: center; !* 縦方向中央揃え *!*/
    /*-webkit-justify-content: center; !* 横方向中央揃え（Safari用） *!*/
    /*justify-content: center; !* 横方向中央揃え *!*/
    margin: 50px 15px 45px 15px;

  }
  #catch{
    font-size: 35px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue